const routeTypes = {
	BOARD: 'board',
	BOARD_BUTLER: 'board-butler',
	BOARD_BUTLER_PAGE: 'board-butler-page',
	BOARD_RECOMMEND: 'board-recommend',
	CARD: 'card',
	ENTERPRISE_ADMIN: 'enterprise-admin',
	ENTERPRISE_ADMIN_TAB: 'enterprise-admin-tab',
	ENTERPRISE_ADMIN_TAB_SUBSECTION: 'enterprise-admin-tab-subsection',
	HOME: 'home',
	TEMPLATES: 'templates',
	TEMPLATES_CATEGORIES: 'templates-categories',
	TEMPLATES_STORY: 'templates-story',
	TEMPLATES_RECOMMEND: 'templates-recommend',
	TEMPLATES_SUBMIT: 'templates-submit',
	TEMPLATE: 'template',
	USER: 'user',
	USER_TABS: 'user-tabs',
	USER_CARDS_WORKSPACE: 'user-cards-workspace',
	VIEW: 'view',
	WORKSPACE: 'workspace',
	WORKSPACE_SECTION: 'workspace-section',
	WORKSPACE_MEMBERS_SUBSECTION: 'workspace-members-subsection',
	WORKSPACE_VIEWS_SUBSECTION: 'workspace-views-subsection',
	POWER_UPS_HOME: 'power-ups-home',
	POWER_UPS_ALL: 'power-ups-all',
	POWER_UPS_TRELLO: 'power-ups-trello',
	POWER_UPS_CATEGORIES: 'power-ups-categories',
	UPGRADE_TEAM: 'select-team-to-upgrade',
	SHORTCUTS: 'shortcuts',
};

// Trello indices of non UGC/PII in the pathname depending on their route type
const ALLOWLIST_INDICES = {
	ROUTE_IDENTIFIER: 0,
	ROUTE_SHORTLINK: 1,
	B_ROUTE_BUTLER: 3,
	B_ROUTE_BUTLER_PAGE: 4,
	B_ROUTE_RECOMMEND: 4,
	E_ROUTE_ADMIN: 2,
	E_ROUTE_ADMIN_TAB_NAME: 3,
	E_ROUTE_ADMIN_TAB_SUBSECTION_NAME: 4,
	POWER_UPS_ROUTE_PAGE: 1,
	POWER_UPS_ROUTE_CATEGORY: 1,
	POWER_UPS_ROUTE_CATEGORY_NAME: 2,
	TEMPLATES_ROUTE_PAGE: 1,
	TEMPLATES_ROUTE_CATEGORY: 1,
	TEMPLATES_ROUTE_TEMPLATE_NAME: 2,
	TEMPLATES_ROUTE_RECOMMEND: 4,
	U_ROUTE_TAB_NAME: 2,
	W_ROUTE_PAGE: 2,
	W_ROUTE_PAGE_SUBSECTION: 3,
};

const routePatternMap = new Map([
	[
		routeTypes.BOARD_RECOMMEND,
		{
			id: routeTypes.BOARD_RECOMMEND,
			regExp: new RegExp('^/b/([^/]+)/([^/]+)/([^/]+)/recommend$'),
			allowlist: [
				ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
				ALLOWLIST_INDICES.ROUTE_SHORTLINK,
				ALLOWLIST_INDICES.B_ROUTE_RECOMMEND,
			],
		},
	],
	[
		routeTypes.BOARD_BUTLER_PAGE,
		{
			id: routeTypes.BOARD_BUTLER_PAGE,
			regExp: new RegExp(
				'^/b/([^/]+)/([^/]+)/butler/(rules|card-buttons|board-buttons|schedule|on-dates|connected-apps)$',
			),
			allowlist: [
				ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
				ALLOWLIST_INDICES.ROUTE_SHORTLINK,
				ALLOWLIST_INDICES.B_ROUTE_BUTLER,
				ALLOWLIST_INDICES.B_ROUTE_BUTLER_PAGE,
			],
		},
	],
	[
		routeTypes.BOARD_BUTLER,
		{
			id: routeTypes.BOARD_BUTLER,
			regExp: new RegExp('^/b/([^/]+)/([^/]+)/butler/$'),
			allowlist: [
				ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
				ALLOWLIST_INDICES.ROUTE_SHORTLINK,
				ALLOWLIST_INDICES.B_ROUTE_BUTLER,
			],
		},
	],
	[
		routeTypes.BOARD,
		{
			id: routeTypes.BOARD,
			regExp: new RegExp('^/b/([^/]+)(?:/(.*?))?$'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER, ALLOWLIST_INDICES.ROUTE_SHORTLINK],
		},
	],
	[
		routeTypes.CARD,
		{
			id: routeTypes.CARD,
			regExp: new RegExp('^/c/'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER, ALLOWLIST_INDICES.ROUTE_SHORTLINK],
		},
	],
	[
		routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
		{
			id: routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
			regExp: new RegExp(
				'^/e/([^/]+)/admin/(members|workspaces|boards)/(managed|boardguests|deactivated|non-enterprise|pending|public)$',
			),
			allowlist: [
				ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
				ALLOWLIST_INDICES.E_ROUTE_ADMIN,
				ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME,
				ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_SUBSECTION_NAME,
			],
		},
	],
	[
		routeTypes.ENTERPRISE_ADMIN_TAB,
		{
			id: routeTypes.ENTERPRISE_ADMIN_TAB,
			regExp: new RegExp(
				'^/e/([^/]+)/admin/(members|workspaces|settings|attachment-restrictions|boards|power-ups|auditlog|account-administration|sso|api-tokens)$',
			),
			allowlist: [
				ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
				ALLOWLIST_INDICES.E_ROUTE_ADMIN,
				ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME,
			],
		},
	],
	[
		routeTypes.ENTERPRISE_ADMIN,
		{
			id: routeTypes.ENTERPRISE_ADMIN,
			regExp: new RegExp('^/e/([^/]+)/admin$'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER, ALLOWLIST_INDICES.E_ROUTE_ADMIN],
		},
	],
	[
		routeTypes.POWER_UPS_HOME,
		{
			id: routeTypes.POWER_UPS_HOME,
			regExp: new RegExp('^/power-ups$'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER],
		},
	],
	[
		routeTypes.POWER_UPS_ALL,
		{
			id: routeTypes.POWER_UPS_ALL,
			regExp: new RegExp('^/power-ups/all$'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER, ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE],
		},
	],
	[
		routeTypes.POWER_UPS_TRELLO,
		{
			id: routeTypes.POWER_UPS_TRELLO,
			regExp: new RegExp('^/power-ups/made-by-trello$'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER, ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE],
		},
	],
	[
		routeTypes.POWER_UPS_CATEGORIES,
		{
			id: routeTypes.POWER_UPS_CATEGORIES,
			regExp: new RegExp(
				'^/power-ups/category/(automation|analytics-reporting|board-utilities|communication-collaboration|developer-tools|file-management|hr-operations|it-project-management|marketing-social-media|product-design|sales-support)$',
			),
			allowlist: [
				ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
				ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY,
				ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY_NAME,
			],
		},
	],
	[
		routeTypes.HOME,
		{
			id: routeTypes.HOME,
			regExp: new RegExp('^/$'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER],
		},
	],
	[
		routeTypes.UPGRADE_TEAM,
		{
			id: routeTypes.UPGRADE_TEAM,
			regExp: new RegExp('^/select-team-to-upgrade$'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER],
		},
	],
	[
		routeTypes.SHORTCUTS,
		{
			id: routeTypes.SHORTCUTS,
			regExp: new RegExp('^/shortcuts$'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER],
		},
	],
	[
		routeTypes.TEMPLATES_SUBMIT,
		{
			id: routeTypes.TEMPLATES_SUBMIT,
			regExp: new RegExp('^/templates/submit$'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER, ALLOWLIST_INDICES.TEMPLATES_ROUTE_PAGE],
		},
	],
	[
		routeTypes.TEMPLATES_RECOMMEND,
		{
			id: routeTypes.TEMPLATES_RECOMMEND,
			regExp: new RegExp('^/templates/([^/]+)/([^/]+)/([^/]+)/recommend$'),
			allowlist: [
				ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
				ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
				ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME,
				ALLOWLIST_INDICES.TEMPLATES_ROUTE_RECOMMEND,
			],
		},
	],
	[
		routeTypes.TEMPLATES_CATEGORIES,
		{
			id: routeTypes.TEMPLATES_CATEGORIES,
			regExp: new RegExp(
				'^/templates/(business|design|education|engineering|marketing|operations-hr|personal|productivity|product-management|project-management|remote-work|sales|support|team-management)$',
			),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER, ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY],
		},
	],
	[
		routeTypes.TEMPLATES_STORY,
		{
			id: routeTypes.TEMPLATES_STORY,
			regExp: new RegExp('^/templates/([^/]+)/([^/]+)$'),
			allowlist: [
				ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
				ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
				ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME,
			],
		},
	],
	[
		routeTypes.TEMPLATES,
		{
			id: routeTypes.TEMPLATES,
			regExp: new RegExp('^/templates$'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER],
		},
	],
	[
		routeTypes.USER_CARDS_WORKSPACE,
		{
			id: routeTypes.USER_CARDS_WORKSPACE,
			regExp: new RegExp('^/u/([^/]+)/cards/([^/]+)$'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER, ALLOWLIST_INDICES.U_ROUTE_TAB_NAME],
		},
	],
	[
		routeTypes.USER_TABS,
		{
			id: routeTypes.USER_TABS,
			regExp: new RegExp('^/u/([^/]+)/(profile|activity|boards|cards|labs|tasks)$'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER, ALLOWLIST_INDICES.U_ROUTE_TAB_NAME],
		},
	],
	[
		routeTypes.USER,
		{
			id: routeTypes.USER,
			regExp: new RegExp('^/u/'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER],
		},
	],
	[
		routeTypes.VIEW,
		{
			id: routeTypes.VIEW,
			regExp: new RegExp('^/v/'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER, ALLOWLIST_INDICES.ROUTE_SHORTLINK],
		},
	],
	[
		routeTypes.WORKSPACE_SECTION,
		{
			id: routeTypes.WORKSPACE_SECTION,
			regExp: new RegExp(
				'^/w/([^/]+)/(account|billing|home|export|free-trial|members|tables|getting-started|highlights|reports)$',
			),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER, ALLOWLIST_INDICES.W_ROUTE_PAGE],
		},
	],
	[
		routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
		{
			id: routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
			regExp: new RegExp('^/w/([^/]+)/members/(guests|requests)$'),
			allowlist: [
				ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
				ALLOWLIST_INDICES.W_ROUTE_PAGE,
				ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION,
			],
		},
	],
	[
		routeTypes.WORKSPACE_VIEWS_SUBSECTION,
		{
			id: routeTypes.WORKSPACE_VIEWS_SUBSECTION,
			regExp: new RegExp('^/w/([^/]+)/views/(table|calendar|)$'),
			allowlist: [
				ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
				ALLOWLIST_INDICES.W_ROUTE_PAGE,
				ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION,
			],
		},
	],
	[
		routeTypes.WORKSPACE,
		{
			id: routeTypes.WORKSPACE,
			regExp: new RegExp('^/w/'),
			allowlist: [ALLOWLIST_INDICES.ROUTE_IDENTIFIER],
		},
	],
]);

export class TrelloUrlScrubber {
	private static _determineRoute(urlPathname: string) {
		const routePatternArray = Array.from(routePatternMap.values());
		for (const routeDefinition of routePatternArray) {
			if (routeDefinition.regExp.exec(urlPathname)) {
				return routeDefinition;
			}
		}
		return null;
	}

	// reconstructs the pathname to include sections that do NOT include UGC/PII
	private static _reconstructPathname(pathnameSections: string[], sectionsToKeep: number[]) {
		let reconstructedUrl = '';
		for (let i = 0; i < pathnameSections.length; i++) {
			if (sectionsToKeep.includes(i)) {
				reconstructedUrl += '/' + pathnameSections[i];
			}
		}
		return reconstructedUrl;
	}

	// finds the matching route for the pathname we want to include in our marketing
	// analytics and then sanitizes it of UGC/PII
	public static scrubUrl(urlPathname: string, defaultPathname: string) {
		const matchingRoute = TrelloUrlScrubber._determineRoute(urlPathname);
		// remove starting slash to allow matchers to use ^ properly
		const partialUrl = urlPathname.substring(1, urlPathname.length);
		const pathnameSections = partialUrl.split('/');
		// to avoid UGC/PII related HOTs, we should be extra cautious & return a
		// generic path for URLs that don't follow a known pattern
		return matchingRoute
			? TrelloUrlScrubber._reconstructPathname(pathnameSections, matchingRoute.allowlist)
			: defaultPathname;
	}
}
